import { ContentFileDto } from '@/api/contents';
import { PagedBox } from '@/types/squadrons';

export enum FileExportFormat {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export type ContentPreviewFileDto = ContentFileDto & {
  isError: boolean;
  isLoading: boolean;
  isCustomizable?: boolean;
  quadrants?: PagedBox[];
  originalDimensions?:
    | { width: number; height: number; type: 'image' | 'pdf' | 'social-file' }
    | Record<
        number,
        { width: number; height: number; type: 'image' | 'pdf' | 'social-file' }
      >;
};
